import React from 'react';
import ImageWrapper from './ImageWrapper';

const WithPicLayout = ({ 
  children, 
  image, 
  imagePosition = 'right', 
  className = 'with-pic',
  imageSize = 'big'
}) => {
  const content = <div>{children}</div>;
  const imageElement = image ? (
    <ImageWrapper
      fluid={image}
      size={imageSize}
      wrapper={true}
    />
  ) : null;

  return (
    <div className={className}>
      {imagePosition === 'left' ? (
        <>
          {imageElement}
          {content}
        </>
      ) : (
        <>
          {content}
          {imageElement}
        </>
      )}
    </div>
  );
};

export default WithPicLayout;